export const ROLES = {
  ACCOUNTANT: 'Hisobchi',
  ADMIN: 'Admin',
  CLIENT: 'Mijoz',
  SALES_MANAGER: 'Sotuv menejeri',
}

export const USER_ROLES = {
  ADMIN: 'admin',
  ACCOUNTANT: 'account',
  INVESTOR: 'investor',
  SALES_MANAGER: 'sales_manager',
}
